// When changing, OrderTypeBadge/index.module.scss styles file must be also changed
export enum OrderTypeBadgeEnum {
	TOTAL,
	DELIVERIES,
	PICKUPS,
	REQUISITIONS,
	UNASSIGNED,
	COMPLETED,
	CANCELLED
}